import {useEffect} from "react";

export default function SetNoIndex() {
    useEffect(() => {
        let lab: HTMLMetaElement | null = null;

        lab = document.createElement("meta");
        lab.name = "robots";
        lab.content = "noindex";

        document.head.appendChild(lab);

        return () => {
            if (lab) {
                document.head.removeChild(lab);
            }
        };
    }, []);
}
